import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import placeholders from '../data/placeholders';
import formatting from '../utils/formatting';
import DataItem from '../data/Item';
import MissingValue from './MissingValue';
/**
 * @param {import('./types').PlaceholderFormatterProps} props
 **/

var renderTemplate = function renderTemplate(_ref) {
  var template = _ref.template,
      id = _ref.id,
      dataType = _ref.dataType,
      value = _ref.value,
      capitalize = _ref.capitalize;
  var out = placeholders(template, {
    id: id,
    dataType: dataType
  }, value);
  if (capitalize) out = formatting.capitalize(out);
  return out;
};

var get = function get(options) {
  var out = renderTemplate(options);
  var hasValue = MissingValue.isSpecified(out, options);
  if (!hasValue) return options.fallback;
  return React.createElement("span", null, out);
};
/**
 * @param {import('./types').PlaceholderFormatterProps} props
 **/


var Placeholders = function Placeholders(props) {
  //direct data
  if (props.value) return get(props); //fetch data if missing

  return React.createElement(DataItem, props, function (_ref2) {
    var value = _ref2.value,
        loading = _ref2.loading;
    if (!value && loading) return null;

    if (!props.children) {
      return get(_objectSpread({}, props, {
        value: value
      }));
    } else {
      return props.children(renderTemplate(_objectSpread({}, props, {
        value: value
      })));
    }
  });
};

Placeholders.defaultProps = {
  capitalize: false,
  template: '{label}',
  fallback: React.createElement(MissingValue, null)
};
export default Placeholders;